<template>
  <ul
    data-sidebar="menu-sub"
    class="ml-2 mr-0 flex min-w-0 max-w-full flex-col gap-0.5 border-l-2 border-n-weak pl-2 pr-0 py-1 group-data-[collapsible=icon]:hidden list-none overflow-hidden"
  >
    <slot />
  </ul>
</template>
